import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'
import { QUERY_KEY_JOBS_VIEWS } from './useApiMenuGetAllJobsViews'
import { NavigationMenu } from '../../../components/common/mygame/menu/menu-interface'

export const useApiMenuPutJobsViews = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: NavigationMenu) => axios.put('/navigation_menu', payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEY_JOBS_VIEWS] })
    }
  })
}
